export const removeAccents = (value) =>
	value
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[^a-z0-9; ªº-]/gi, '')

export const processStatusFilters = (selectedStatuses) => {
	if (!selectedStatuses || selectedStatuses.length === 0) return []

	const currentSelections = Array.isArray(selectedStatuses)
		? selectedStatuses
		: [selectedStatuses]

	const processed = currentSelections.flatMap((status) => {
		if (status === 'GROUP_IN_PROGRESS') {
			return ['Em Validação', 'Em Revisão', 'Atrasado']
		}
		return status
	})

	return [...new Set(processed)]
}
